// extracted by mini-css-extract-plugin
export default {"videoContainer":"AddVideoResponseButton__videoContainer___reDrT"};